import { Create, useSelect, useForm } from "@refinedev/antd";
import { Form, Input, Select, Tag, Space } from "antd";
import { IResourceComponentsProps } from "@refinedev/core";
import { DesktopOutlined } from "@ant-design/icons";

import { IVessel, IEcdis } from "interfaces";
import React from "react";
import { FormSection, FormFieldGrid } from "components/form";

export const EcdisCreate: React.FC<IResourceComponentsProps> = () => {
  const {
    formProps,
    saveButtonProps,
    formLoading: isLoading,
  } = useForm<IEcdis>({ redirect: "list" });

  const { selectProps } = useSelect<IVessel>({
    resource: "vessel",
    optionLabel: "imoNumber",
    optionValue: "id",

    pagination: {
      mode: "server"
    }
  });

  return (
    <Create
      breadcrumb={false}
      saveButtonProps={saveButtonProps}
      headerProps={{
        onBack: () => window.history.back(),
        title: "Create ECDIS",
        subTitle: "setup new ECDIS",
        tags: isLoading ? (
          <Tag color="orange">loading</Tag>
        ) : (
          <Tag color="green">live</Tag>
        ),
      }}
    >
      <Form {...formProps} layout="vertical">
        <Space direction="vertical" size={24} style={{ width: "100%" }}>
          <FormSection
            title="ECDIS Information"
            subtitle="Electronic Chart Display and Information System details"
            icon={<DesktopOutlined />}
            variant="elevated"
          >
            <FormFieldGrid columns={2}>
              <Form.Item
                label="Make"
                name="make"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Model"
                name="model"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Vessel IMO Number"
                name={["vessel", "id"]}
                rules={[{ required: true }]}
              >
                <Select {...selectProps} />
              </Form.Item>
            </FormFieldGrid>
          </FormSection>
        </Space>
      </Form>
    </Create>
  );
};
